import en from './en/translation.json';
import it from './it/translation.json';
import pt from './pt/translation.json';
import ru from './ru/translation.json';
import tr from './tr/translation.json';
import ua from './ua/translation.json';
import vi from './vi/translation.json';
import zhHans from './zh-hans/translation.json';
import zhHant from './zh-hant/translation.json';

export default {
    en: en,
    it: it,
    pt: pt,
    ru: ru,
    tr: tr,
    ua: ua,
    vi: vi,
    zhHans: zhHans,
    zhHant: zhHant,
};
